import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'angularforms-overlay',
  templateUrl: './angularforms-overlay.component.html',
  styleUrls: ['./angularforms-overlay.component.css']
})
export class AngularformsOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
